<div class="diaContainer">
    <h1 mat-dialog-title>Add Options</h1>
    <p>(Min:2 Max:10)</p>
    <p *ngIf="dupOpts" style="font-weight: bolder;">Please remove the duplicate options
      <span title="Duplicate options warning" style="height: 24px;">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" style="width: 24px; vertical-align: sub;"><path fill="#D0342C" d="M21.912 20.173L12.813 3.478c-.265-.442-.795-.618-1.237-.353a.69.69 0 0 0-.353.353L2.125 20.173c-.265.442-.089.972.353 1.237.088.088.265.088.442.088h18.197c.53 0 .883-.441.883-.883 0-.177 0-.265-.088-.442zm-9.01-2.208h-1.767v-1.767H12.9v1.767zm0-3.534h-1.767v-5.3H12.9v5.3z"></path></svg>
      </span>.
    </p>
    <div class="optDialog" *ngFor="let opt of optArr">
        <p>{{opt}}</p>
        
        <div class="optDialog">
          <button mat-icon-button (click)="removeOpt(opt)" [title]="'Remove'">
            <i class="one-icons">circle_remove</i>
          </button>
          <button mat-icon-button (click)="editOpt(opt)" [title]="'Edit'">
            <i class="one-icons">edit</i>
          </button>
        </div>
    </div>

    <div class="optDialog" mat-dialog-content>

        <mat-form-field *ngIf="fieldFlag">
            <mat-label>Add Option</mat-label>
            <input matInput [(ngModel)]="opts" [maxlength]="charLimit">
        </mat-form-field>
        
        <div class="optDialog">
            <button mat-icon-button (click)="addOpt()" *ngIf="!disableFlag" [title]="'Add'">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>
            </button>
            <button mat-icon-button (click)="updateOpt(opts)" *ngIf="updateFlag" [title]="'Update'">
              <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><g><rect fill="none" height="24" width="24" x="0"/></g><g><g><g><path d="M21,10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-0.1c-2.73,2.71-2.73,7.08,0,9.79s7.15,2.71,9.88,0 C18.32,15.65,19,14.08,19,12.1h2c0,1.98-0.88,4.55-2.64,6.29c-3.51,3.48-9.21,3.48-12.72,0c-3.5-3.47-3.53-9.11-0.02-12.58 s9.14-3.47,12.65,0L21,3V10.12z M12.5,8v4.25l3.5,2.08l-0.72,1.21L11,13V8H12.5z"/></g></g></g></svg>
            </button>
        </div>
    </div>

    <div mat-dialog-actions>
      <button mat-stroked-button one-secondary-button (click)="onCancel()">Cancel</button>
      <button color="primary" mat-raised-button mat-dialog-close (click)="onConfirm()" [disabled]="!isConfirm || dupOpts">Confirm</button>
    </div>
</div>
